import type { HelpFile } from '../../types/help'
import { MyTestIds } from '../../../testids/MyTestIds'

export const myHelp: HelpFile = {
  texts: {
    [MyTestIds.myRehiresBadge]:
      'Number of rehire candidates whose matched identity reports to you and is awaiting your decision.',
  },
}
